import { render } from "./AppNotifications.vue?vue&type=template&id=eb9c52cc&scoped=true&ts=true"
import script from "./AppNotifications.vue?vue&type=script&lang=ts"
export * from "./AppNotifications.vue?vue&type=script&lang=ts"

import "./AppNotifications.vue?vue&type=style&index=0&id=eb9c52cc&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb9c52cc"]])

export default __exports__